












import { Component, Mixins } from "vue-property-decorator";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { RectangleCoordinatableObjectDrawerBase } from "./base";

@Component({
  components: {
    RectangleDragHandles,
  },
})
export default class PositionCorrectionObjectDrawer extends Mixins(RectangleCoordinatableObjectDrawerBase) {}
